import SessionService from "../service/SessionService";
import { Constants } from "../Constants";
import { Link } from "react-router-dom";

export function canUserActionAccess() {
	let user_info = SessionService.getUserInfo();
	return (
		user_info.role === Constants.userRole.SYSTEM_ADMIN ||
		user_info.role === Constants.userRole.RTO_ADMIN ||
		user_info.role === Constants.userRole.ORG_ADMIN ||
		user_info.role === Constants.userRole.COMPANY_ADMIN ||
		user_info.role === Constants.userRole.STORE_ADMIN
	);
}

export function createGridStructLink(hrefText, text) {
	if (SessionService.canSystemAdmin() || SessionService.canRtoAdmin()) {
		return <Link to={`${hrefText}`}>{text}</Link>;
	} else {
		return text;
	}
}

export function generateGridStructOptions(
	columnName,
	tableColumns,
	initialDisplay = true,
	filterDisplay = true,
	columnsDisplay = true,
	excluded = false
) {
	if (tableColumns) {
		return {
			...(excluded
				? { display: false }
				: tableColumns === undefined ||
				  Object.keys(tableColumns).length === 0
				? { display: initialDisplay }
				: tableColumns.hasOwnProperty(columnName)
				? {}
				: { display: false }),
			filter:
				tableColumns.hasOwnProperty(columnName) &&
				filterDisplay &&
				!excluded,
			viewColumns:
				tableColumns.hasOwnProperty(columnName) &&
				columnsDisplay &&
				!excluded,
		};
	}
}

/*
 * This function is used to parse a date string in the format YYYY-MM-DD
 * into a JavaScript Date object
 *
 * @param dateString: a date string in the format YYYY-MM-DD
 * @returns a JavaScript Date object
 */
export function parseDateString(dateString) {
	const [year, month, day] = dateString.split("-").map(Number);
	// Please note that months in JavaScript's Date object are 0-indexed
	return new Date(year, month - 1, day);
}

export function parseErrorObject(errorObject) {
	let errorMessage = "";
	for (const key in errorObject) {
		if (errorObject.hasOwnProperty(key)) {
			errorMessage += errorObject[key] + "\n";
		}
	}
	return errorMessage;
}

export function getPaymentImage(key) {
	switch (key) {
		case "MC":
			return (
				<img
					src="/images/card_master.png"
					class="rto_card-logo-sm"
					alt=""
				/>
			);
		case "VISA":
			return (
				<img
					src="/images/card_visa.png"
					class="rto_card-logo-sm"
					alt=""
				/>
			);
		case "DISC":
			return (
				<img
					src="/images/card_discover.png"
					class="rto_card-logo-sm"
					alt=""
				/>
			);
		case "AMEX":
			return (
				<img
					src="/images/card_amex.png"
					class="rto_card-logo-sm"
					alt=""
				/>
			);
		default:
			return (
				<img
					src="/images/card_default.png"
					class="rto_card-logo-sm"
					alt=""
				/>
			);
	}
}

export function saveFile(fileContentType, data, fileName) {
	var blob = new Blob([s2ab(atob(data))], { type: fileContentType });

	if (window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveBlob(blob, fileName);
	} else {
		var elem = window.document.createElement("a");
		elem.href = window.URL.createObjectURL(blob);
		elem.download = fileName;
		document.body.appendChild(elem);
		elem.click();
		document.body.removeChild(elem);
	}
}

export function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);

	for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
	return buf;
}
